import React from 'react'
import {default as Links} from "../../Route";
import Link from "../../components/Link";
import AuthenticationContext from "../../services/AuthenticationContext";
import AuthenticationAPI from "../../services/AuthenticationAPI";

const
    defaultMenuKey = "",
    menu = [
    {
        key: Links.Home.link,
        type: "a",
        className: "nav-link",
        href: Links.Home.link,
        label: Links.Home.label,
        handleClick: null,
        attributes: {
            "data-key": Links.Home.link
        },
    },
    {
        key: Links.Association.link,
        type: "a",
        className: "nav-link",
        href: Links.Association.link,
        label: Links.Association.label,
        handleClick: null,
        attributes: {
            "data-key": Links.Association.link
        },
    },
    {
        key: Links.Activities.link,
        type: "a",
        className: "nav-link",
        href: Links.Activities.link,
        label: Links.Activities.label,
        handleClick: null,
        attributes: {
            "data-key": Links.Activities.link
        },
    },
    {
        key: Links.Directory.link,
        type: "a",
        className: "nav-link",
        href: Links.Directory.link,
        label: Links.Directory.label,
        handleClick: null,
        attributes: {
            "data-key": Links.Directory.link
        },
    },
    {
        key: Links.News.link,
        type: "a",
        className: "nav-link",
        href: Links.News.link,
        label: Links.News.label,
        handleClick: null,
        attributes: {
            "data-key": Links.News.link
        },
    },
    {
        key: Links.Contact.link,
        type: "a",
        className: "nav-link",
        href: Links.Contact.link,
        label: Links.Contact.label,
        handleClick: null,
        attributes: {
            "data-key": Links.Contact.link
        },
    },
]
export default class Header extends React.Component{
    static contextType = AuthenticationContext;
    constructor(props) {
        super(props);
        this.user = null;
        this.state = {
            activeMenu: defaultMenuKey,
        };
        this.handleMenuTopClick = this.handleMenuTopClick.bind(this);
    }

    handleMenuTopClick(event){
        const activeMenu = event.target.getAttribute("data-key");
        if(this.state.activeMenu !== activeMenu){
            this.setState({activeMenu: activeMenu});
        }
    }

    /**
     *
     * @return {JSX.Element}
     */
    render(){
        const styleForContact = {
            color:"white",
            fontWeight: "bold",
            fontFamily: "sans-serif",
        };
        return (
            <nav className="navbar navbar-default navbar-fixed-top">
                <div className="submenu">
                    <span className="ribbon"></span>
                    <div className="container">
                        <ul className="nav navbar-nav navbar-right">
                            <li className="link-btn">
                                <span className="fa fa-envelope">
                                    <a style={styleForContact} href="mailto:contact@association-iaicongo.org"> contact@association-iaicongo.org</a>
                                </span>
                            </li>
                            <li className="link-btn">
                                <span className="fa fa-phone">
                                    <a style={styleForContact} href="tel:242068389195"> +242 06 838 91 95</a>
                                </span>
                            </li>
                        </ul>
                        <ul className="nav navbar-nav navbar-right">
                            {
                                this.context.isAuthenticated === true ?
                                    <>
                                        <li className="link-btn"><a href={Links.Logout.link} className="btn btn-primary">{Links.Logout.label}</a></li>
                                        <li className="link-btn"><a href={Links.MemberProfile.link} className="btn btn-primary">{Links.MemberProfile.label}</a></li>
                                        {AuthenticationAPI.hasAdminSpaceAuthorization() ? <li className="link-btn"><a href={Links.Administration.link} className="btn btn-primary">{Links.Administration.label}</a></li> : ""}
                                    </>
                                    :
                                    <>
                                        <li className="link">
                                            <span className="fa fa-lock"></span>
                                            <Link data={{
                                                type: "NavLink",
                                                className: "active",
                                                href: Links.Join.link,
                                                label: Links.Join.label,
                                                attributes: "",
                                                handleClick: null,
                                            }} />
                                        </li>
                                        <li className="link-btn"><a href={Links.SignIn.link} className="btn btn-primary">{Links.SignIn.label}</a></li>
                                    </>
                            }

                        </ul>
                    </div>
                </div>

                <div className="mainmenu">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#myMenu">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a className="navbar-brand fix-logo-iai" href={Links.Home.link}>
                                <img src="/assets/images/brand/logo-iai-header-2.png" alt="logo-iai" height="90" width="76" />
                            </a>
                        </div>

                        <div className="collapse navbar-collapse" id="myMenu">
                            <TopMenu handleClick={this.handleMenuTopClick} data={{
                                menu: menu,
                                activeMenu: this.state.activeMenu
                            }} />
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}

const TopMenu = (props) => {
    const menu = props.data.menu,
        list = menu.map((item) => {
            let active = item.className + (item.key === props.data.activeMenu ? " active" : "");
            return <li key={item.key} className={"nav-item " + active}>
                <Link data={{
                    type: "NavLink",
                    className: active,
                    href: item.href,
                    label: item.label,
                    attributes: item.attributes,
                    handleClick: props.handleClick,
                }} />
            </li>
        })
    ;

    return (
        <ul className="nav navbar-nav navbar-right">
            {list}
        </ul>
    );
};